export const getAccessModalAction = (accountAccessMode?: string): 'step_1' | 'step_2_new_account' | 'step_2_existing_account' | undefined => {
  if (!accountAccessMode) return

  const modeToActionMapping = {
    login: 'step_1',
    join: 'step_2_new_account',
    loginPassword: 'step_2_existing_account',
  }

  return modeToActionMapping[accountAccessMode]
}
